/* Main Fund Explorer JS bundle */
require("./main.js");

//Libs
require("./funds/ie11-polyfill.js");
require("./funds/FileSaver.min.js");
require("./funds/moment.min.js");
require("./funds/daterangepicker.min.js");
require("highcharts/highcharts.js");

//Vshift
require("./funds/scripts.js");

//VanEck
require("./funds/fund-charts-page.js");
require("./funds/fund-listing-charts.js");
